import { render } from "./TopBar.vue?vue&type=template&id=736547ba"
const script = {}

import "./TopBar.vue?vue&type=style&index=0&id=736547ba&lang=scss"

import exportComponent from "C:\\Users\\ATL\\Desktop\\Dev\\p2-osavus\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__